(() => {
  // Évite boucles
  let running = false;
  let lastRunAt = 0;

  const now = () => Date.now();

  async function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
  }

  function buildParentToGiftMap(cart) {
    // parentVariantId -> giftVariantId
    const map = new Map();
    (cart.items || []).forEach((it) => {
      const parentId = it?.properties?._upsell_parent_variant_id;
      if (parentId) {
        map.set(String(parentId), String(it.variant_id));
      }
    });
    return map;
  }

  async function changeLine(line, quantity, properties) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity, properties }),
    });
    return res.json();
  }

  async function sync() {
    // throttle léger (évite spam si thème fait 10 updates)
    if (running) return;
    if (now() - lastRunAt < 250) return;

    running = true;
    lastRunAt = now();

    try {
      const cart = await fetchCart();
      const map = buildParentToGiftMap(cart);

      if (map.size === 0) return;

      // Patch parents: subscription_free_gift_variant_id (et optionnellement subscription_free_gift_code)
      for (let i = 0; i < (cart.items || []).length; i++) {
        const it = cart.items[i];

        const parentVariantId = String(it.id);
        const giftVariantId = map.get(parentVariantId);
        if (!giftVariantId) continue;

        const currentGiftVar = it?.properties?.subscription_free_gift_variant_id
          ? String(it.properties.subscription_free_gift_variant_id)
          : "";

        // Si déjà OK, rien à faire
        if (currentGiftVar && currentGiftVar === giftVariantId) continue;

        // Merge TOUTES les properties existantes (ne casse pas Seal)
        const mergedProps = Object.assign({}, it.properties || {}, {
          subscription_free_gift_variant_id: giftVariantId,
          // Si tu veux aussi remplacer ton ESSENTIEL_BN par le vrai variant id:
          subscription_free_gift_code: giftVariantId,
        });

        const line = i + 1;
        const out = await changeLine(line, it.quantity, mergedProps);

        if (out && out.status) {
          console.error("[MOODZ_GIFT_SYNC] change.js error", out);
          break;
        }
      }
    } catch (e) {
      console.error("[MOODZ_GIFT_SYNC] exception", e);
    } finally {
      running = false;
    }
  }

  // ---- Trigger robuste : on hook toutes les opérations panier AJAX
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await originalFetch.apply(this, args);

    try {
      const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
      // Quand Shopify met à jour le panier, on sync juste après
      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear")
      ) {
        // petit delay pour laisser le thème finir ses renders
        setTimeout(sync, 80);
      }
    } catch (_) {}

    return res;
  };

  // 1er sync au chargement (si un panier déjà rempli)
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(sync, 200);
  });
})();
